import { useQuery } from "@tanstack/react-query";
import BrieCostTrackerAPI from "../../../api/api/BrieCostTrackerAPI";

const useOverAllCosts = (
  type: "month" | "year",
  month: number,
  year: number,
  tenantID?: string
) => {
  const costs = useQuery({
    queryKey: ["overall-costs", tenantID, month, year, type],
    queryFn: async () => {
      const apiResponse = await BrieCostTrackerAPI.getOverAllCloudCosts(
        tenantID || "",
        month,
        year,
        type
      );
      return apiResponse.data.data;
    },
    enabled: !!tenantID,
  });

  return {
    costs: costs.data,
    costsLoading: costs.isLoading,
    costsError: costs.error,
  };
};

export default useOverAllCosts;
